<script>
  import Dropdown from '@components/general/dropdown.svelte'
  import TriggerChevron from '@components/general/trigger-chevron.svelte'
  import Button from '@components/buttons/button.svelte'
  import { colors } from '@lib/utils/colors'
  import { cn } from '@lib/utils'
  import { CheckCircle } from 'lucide-svelte'
  
  let { color = $bindable(""), named = true, width = "20rem", closeOnSelect = true, class: className, buttonProps = {}, ...restProps } = $props()

  let open = $state(false)
  
  function handleSelect(colorItem) {
    color = colorItem
    if (closeOnSelect) open = false
  }

</script>

{#snippet circle(color)}
  {#if color}
    <span class={cn(colors[color]?.base, "w-3 h-3 rounded-full")}></span>
  {:else}
    <span class="w-3 h-3 rounded-full bg-transparent border border-gray-200"></span>
  {/if}
{/snippet}

<Dropdown {width} class={className} align="start" bind:open {...restProps}>
  
  {#snippet trigger({ props })}
    <Button variant="outline" text={color} class="hover:bg-transparent" {...buttonProps} {...props}>
      {@render circle(color)}
      {#if named}
        <span>{color || "No color"}</span>
      {/if}
      <TriggerChevron bind:open class="text-gray-400 ml-auto" />
    </Button>
  {/snippet}

  {#snippet contents()}
    <!-- Allow an empty option -->
    <Button variant="menu_item" class="w-full" onclick={() => handleSelect("")}>
      {@render circle("")}
      <span>No color</span>
    </Button>
    {#each Object.keys(colors) as colorItem (colorItem)}
      <div style={`width: ${width};`}>
        <Button variant="menu_item" class="w-full" onclick={() => handleSelect(colorItem)}>
          {@render circle(colorItem)}
          <span>{colorItem}</span>
          {#if colorItem === color}
            <CheckCircle size={14} class="ml-auto text-green-500/70" />
          {/if}
        </Button>
      </div>
    {/each}
  {/snippet}
</Dropdown>